import { render, staticRenderFns } from "./DialogSpecNotAvailable.vue?vue&type=template&id=7ef47996&"
import script from "./DialogSpecNotAvailable.vue?vue&type=script&lang=js&"
export * from "./DialogSpecNotAvailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ef47996')) {
      api.createRecord('7ef47996', component.options)
    } else {
      api.reload('7ef47996', component.options)
    }
    module.hot.accept("./DialogSpecNotAvailable.vue?vue&type=template&id=7ef47996&", function () {
      api.rerender('7ef47996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DialogSpecNotAvailable/DialogSpecNotAvailable.vue"
export default component.exports